import React from 'react';
import Text from '@amzn/meridian/text';
import DisplaySubMetric from './DisplaySubMetric';
import Row from '@amzn/meridian/row';
import { FormattedMessage } from 'react-intl';
import { DisplaySubMetricsProps } from '../types';
import {
  PRRCIDataCheck,
  SUBMETRIC_FONT_SIZE,
  SUBMETRIC_ROW_WIDTHS,
} from '../helper';
import { ControlledExpander } from './Util/ControlledExpander';
import Column from '@amzn/meridian/column';
import NoSubMetric from './Util/NoSubMetric';

const DisplayPRRCISubMetrics: React.FC<DisplaySubMetricsProps> = ({
  metrics,
}: DisplaySubMetricsProps): React.ReactElement => {
  if (!metrics.PRRCI?.submetrics) {
    return <></>;
  }
  if (PRRCIDataCheck(metrics.PRRCI?.submetrics!)) {
    return <NoSubMetric />;
  }
  const { understandabilityConcessionIssued } = metrics.PRRCI?.submetrics!;

  return (
    <Column spacing='none' width='100%'>
      {understandabilityConcessionIssued && (
        <Row
          alignmentVertical='top'
          width='100%'
          widths={SUBMETRIC_ROW_WIDTHS}
          spacing='none'
          spacingInset='none none 200'
        >
          <ControlledExpander
            title={
              <Text type={SUBMETRIC_FONT_SIZE}>
                <FormattedMessage
                  id='cs_perfportal_lighthouse_understandability_concessionIssued'
                  defaultMessage='Understandability - Concession Issued'
                />
              </Text>
            }
            type='list'
          >
            <Text type={SUBMETRIC_FONT_SIZE}>
              <FormattedMessage
                id='cs_perfportal_lighthouse_understandability_concessionIssued_def'
                defaultMessage='Percentage of 4 to 5-star responses to the “Easy to Understand” CCX rating of contacts where a concession was issued.'
              />
            </Text>
          </ControlledExpander>
          <DisplaySubMetric
            value={understandabilityConcessionIssued.datapoint}
            isBold
            isPercentage
          />
          <DisplaySubMetric
            value={understandabilityConcessionIssued.networkAverage}
            isPercentage
            datapointNull={understandabilityConcessionIssued.datapoint === null}
          />
        </Row>
      )}
    </Column>
  );
};

export default DisplayPRRCISubMetrics;
